export default __webpack_public_path__ + "static/media/top3-logo.2d580bf9.webp";